export default {
  clients_pending: false,
  clients: []
}
